import React from "react";

export const IconWrapper = ({ children, handleClick }) => (
    <span className={`icon__accessibility`} onClick={(e) => {
        if (handleClick) {
            e.stopPropagation();
            handleClick(e);
        } else {}
    }}>
        {children}
    </span>
);
